import React, { useEffect } from "react";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { $fontSize, $space } from "@acko-tech/building-blocks.ui.common";
import Card from "@components/common/mobile/card";
import Questions from "@components/common/mobile/questions/vertical";

const Subtext = styled(Text)`
  font-size: ${$fontSize.xxs};
  line-height: 1rem;
  text-align: center;
  margin-top: ${$space.m};
`;

function QuestionsCard({
  question,
  description,
  options,
  fullWidthOptions,
  selectedValue,
  subtext,
  handleClick,
  onMount,
  questionStyles,
  cardStyles,
  columnBreak,
  showButton,
  buttonOnClick,
  showError,
  errorMessage,
  selectedList,
  innerContainerStyles
}: Props): JSX.Element {
  useEffect(() => {
    if (onMount) onMount();
  }, []);
  return (
    <Card styles={cardStyles}>
      <Questions
        question={question}
        description={description}
        options={options}
        fullWidthOptions={fullWidthOptions}
        selectedValue={selectedValue}
        handleClick={handleClick}
        questionStyles={questionStyles}
        columnBreak={columnBreak}
        showButton={showButton}
        buttonOnClick={buttonOnClick}
        showError={showError}
        errorMessage={errorMessage}
        selectedList={selectedList}
        innerContainerStyles={innerContainerStyles}
      />

      {subtext && <Subtext>{subtext}</Subtext>}
    </Card>
  );
}

interface Props {
  question: string;
  description?: string;
  options: Options[];
  fullWidthOptions?: Options[];
  selectedValue?: string;
  handleClick(value: any): void;
  onMount?: Function;
  questionStyles?: any;
  cardStyles?: any;
  showButton?: boolean;
  buttonOnClick?: Function;
  showError?: boolean;
  errorMessage?: string;
  subtext?: string;
  columnBreak?: number;
  selectedList?: any;
  innerContainerStyles?: any;
}

interface Options {
  name: string | number | boolean;
}

export default QuestionsCard;
